import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer3ZakladanieOgrodu from "../../components/offer/3zakladanieOgrodu";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Kompleksowe zakładanie ogrodów od A do Z | Gdańsk, Gdynia, Wejherowo, Kaszuby</title>
        <meta name="title" content="Kompleksowe zakładanie ogrodów od A do Z | Gdańsk, Gdynia, Wejherowo, Kaszuby" />
        <meta
          name="description"
          content="Zakładanie pięknych ogrodów wokół nowych domów: nasadzenia, trawniki, oświetlenie i nawadnianie. Realizacje w Gdańsku, Gdyni, Kartuzach, Wejherowie i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Kompleksowe zakładanie ogrodów od A do Z | Gdańsk, Gdynia, Wejherowo, Kaszuby"
        />
        <meta
          property="og:description"
          content="Zakładanie pięknych ogrodów wokół nowych domów: nasadzenia, trawniki, oświetlenie i nawadnianie. Realizacje w Gdańsku, Gdyni, Kartuzach, Wejherowie i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer3ZakladanieOgrodu />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
